module.exports = __webpack_public_path__ + "static/media/delivery.e3902fcf.svg";